module.exports = __webpack_public_path__ + "ff2249965f9f99bdad798e53e65b9e78.MP3";